import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getConfiguration, putConfiguration } from 'store/thunks';
import * as Yup from "yup";


const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.RETRY_COUNT_POST_NEWS,
            value: String(values?.retry_count ?? '0'),
            is_active: 1,
          },
        ]
      };
      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    retry_count: Yup.number().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      retry_count: 0,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });


  const handleCallAllOption = async () => {
    try {

      const [res1]: any = await Promise.all([getConfiguration({})]);

      const _configs = res1?.data?.list || [];
      const _config_retry_count = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.RETRY_COUNT_POST_NEWS) || {};

      formik?.setFieldValue('retry_count', _config_retry_count?.value || 0);

    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Home')} - ${t('Configuration')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Configuration')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3">
                    <form onSubmit={formik.handleSubmit}>
                      <Row>
                        <Col md={{ size: 4, offset: 4 }} className="px-4 mt-4">
                          <Row>
                            <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                              <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Posts')}</span>

                              <Col sm={12} md={12} xl={12} className='mt-1 '>
                                <Label htmlFor="retry_count" className="form-label">{t('Retry Limit')} <span className="text-danger"> *</span>
                                  {/* <TooltipCustom
                                    title={t("Sets the number of keyword matches in the title when collecting articles.")}
                                    className="d-inline-block vertical-align-middle ms-1"
                                    style={{ transform: 'translateY(1px)' }}
                                  >
                                    <i className="ri-question-line align-bottom text-secondary" ></i>
                                  </TooltipCustom> */}
                                </Label>
                                <Input
                                  className="form-control"
                                  id="retry_count"
                                  name="retry_count"
                                  type="text"
                                  value={formik?.values?.retry_count ?? ''}
                                  placeholder={t('Retry Limit')}
                                  autoComplete='off'
                                  onChange={(event: any) => {
                                    const input = event.target.value;
                                    const onlyNumbers = input.replace(/\D/g, "");
                                    const s = onlyNumbers;
                                    formik.setFieldValue("retry_count", s);
                                  }}
                                />
                                {formik.touched.retry_count && formik.errors.retry_count ? (
                                  <div className="text-danger mt-2">{formik.errors.retry_count}</div>
                                ) : null}
                              </Col>
                              <Col sm={12} md={12} xl={12} className='text-end mt-3'>
                                <button
                                  style={{ width: '150px' }}
                                  type="submit"
                                  disabled={(isLoading)}
                                  className="btn btn-primary fs-14 rounded-pill">
                                  {<>{t('Button Update')}</>}
                                </button>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;

